import { Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';

export default function AddMobileCategoryButton({ onSubmit, postResult }: any) {
  const navigate = useNavigate();
  return (
    <Stack>
      <Button variant="text" onClick={onSubmit}>
        저장
      </Button>
      <ApiResultModal
        apiResult={postResult}
        successTitle="등록됐습니다."
        successCode={201}
        onSuccessClose={() => navigate(`/category`)}
        failTitle="관리자에게 문의해주세요."
        ErrorCodeTable={{
          PAYLOAD_INVALID: { title: '입력값을 확인해주세요' },
        }}
      />
    </Stack>
  );
}
